import React from "react";

import { VAT_INFO } from "@typings/globals";

import { useTranslate } from "@hooks/useTranslate";

interface WithVATLabel {
  vatLabel: string;
}

const useVAT = () => {
  const translate = useTranslate("batmaid_pwa_generic");

  const getVATLabel = (value: VAT_INFO) => {
    switch (value) {
      case VAT_INFO.EXCLUDED:
        return translate("excluding_vat");
      case VAT_INFO.INCLUDED:
        return translate("including_vat");
      case VAT_INFO.NO_INFO:
        return "";
      default:
        return "";
    }
  };

  return {
    getVATLabel,
  };
};

export { useVAT, WithVATLabel };
